import React, { useEffect, useState } from "react";
import AppBar from '@mui/material/AppBar';
import { Box, Grid } from "@mui/material";
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import moment from 'moment-timezone';


export default function AppbarTumbler(props) {
    const today = new Date();
    const hourago = new Date(today.getTime());
    const timestr = moment(hourago).tz('Asia/Bangkok').format('DD MMM YY');

    const [time, setTime] = useState(new Date());

    useEffect(() => {
        const interval = setInterval(() => {
            setTime(new Date());
        }, 1000);

        return () => clearInterval(interval);
    }, []);


    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <AppBar component="nav" style={{ backgroundColor: "#242424", position: "relative" }}>
                <Toolbar variant="string" sx={{ height: 'clamp(33px, 8vh, 100px)'}}>
                    <Grid container spacing={2}>
                        <Grid item xs={5.5}>
                            <Typography
                                style={{ color: "#00ca9b", fontWeight: "bold", fontSize: 'clamp(30px, 3vw, 48px)', position: "relative", left: "0vw"}}
                                textAlign="left"
                            >
                                {props.header}
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                                <Typography
                                    style={{ color: "#ffffff", fontWeight: "bold", fontSize: 'clamp(30px, 3vw, 48px)' }}
                                    textAlign="right"
                                >
                                    {timestr}&nbsp;&nbsp;{time.toLocaleTimeString('en-GB')}
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={0.5}>
                            <Typography
                                style={{ position: "relative", paddingTop: 18 }}
                                textAlign="right"
                            >
                                {props.icon}
                            </Typography>
                        </Grid>
                    </Grid>
                </Toolbar>
            </AppBar>

        </Box>
    );
}
